<template lang="html">
  <div>
    <v-jumbotron height="100%" class="mt-5">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <h3 class="display-3">A verification email was sent!</h3>
            <span class="subheading">Please check your inbox for a verification link. Once you click it, come back and refresh the page to continue</span>
          </v-flex>
          <v-flex xs12 class="mt-3">
            <v-btn @click="sendEmail()" color="primary" large outline round >Resend Email<v-icon right>send</v-icon></v-btn>
            <a href="/" class="clean-link">
              <v-btn color="primary" large outline round >Refresh Page<v-icon right>refresh</v-icon></v-btn>
            </a>
          </v-flex>
        </v-layout>
      </v-container>
    </v-jumbotron>
    <v-snackbar
      v-model="snackbar"
      color="primary"
      :timeout="6000"
      bottom
    >
     Verification email sent!
     <v-btn
       color="white"
       flat
       fab
       @click="snackbar = false"
     >
       <v-icon>close</v-icon>
     </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  data () {
    return {
      snackbar: false
    }
  },
  methods: {
    sendEmail () {
      this.sendEmailVerification()
      this.snackbar = true // not a true indication that it sent, could still fail
    },
    ...mapActions('user', {
      sendEmailVerification: 'sendEmailVerification'
    })
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/Home/Verification.vue